var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlintLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m56.011,59.385l43.4622,-44.0833c2.9708,-3.2534 4.0318,-2.9365 5.0448,0.7872l0.388,31.4881c-0.108,4.9136 -0.465,7.0326 -1.94,9.0528l-26.3881,27.1585c-3.4504,4.2667 -2.9769,5.9698 -3.1044,7.872c-0.1276,1.9022 3.3574,7.4484 9.3133,7.8721c0,0 16.1505,0.0033 17.8502,0c1.7,-0.0034 2.891,2.7346 0,5.5106l-36.4769,36.605c-4.5143,4.252 -7.068,4.24 -11.6416,2.755c-7.0196,-3.935 -7.145,-7.567 -7.3638,-13.901l-0.0093,-0.269l0,-40.1471c-0.2431,-12.7983 1.5866,-19.6181 10.8656,-30.7009z",
    fill: "#FF6100",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.71,131.59l-44.7788,44.083c-3.0611,3.254 -4.154,2.937 -5.1976,-0.787l-0.3998,-31.488c0.1107,-4.913 -0.0753,-2.99857 6.35026,-10.92424l22.83594,-25.28676c3.555,-4.267 3.067,-5.97 3.199,-7.8722c0.131,-1.9022 -3.459,-7.4484 -9.596,-7.8721c0,0 -16.6397,-0.0033 -18.3913,0c-1.7515,0.0034 -2.9787,-2.735 0,-5.5104l37.5823,-36.605c4.651,-4.2523 7.283,-4.2405 11.995,-2.7552c7.232,3.935 7.361,7.5674 7.587,13.9013l0.009,0.2684l0,40.1472c0.251,12.799 -1.634,19.618 -11.195,30.701z",
    fill: "#FF6100",
    id: "svg_2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlintLogo);
export default __webpack_public_path__ + "static/media/flint-logo.be5a7c42623ac917c7026266648b3e00.svg";
export { ForwardRef as ReactComponent };